import {
  Center,
  Loader,
  type LoaderProps,
  Stack,
  Text,
  useMantineTheme,
} from '@mantine/core';

type LoadingIndicatorProps = {
  isFullPageLoading?: boolean;
  message?: string;
  size?: LoaderProps['size'];
};

export const LoadingIndicator = ({
  isFullPageLoading = false,
  message,
  size = 'lg',
  ...loaderProps
}: LoadingIndicatorProps & LoaderProps) => {
  const { primaryColor } = useMantineTheme();

  const Loading = <Loader color={primaryColor} size={size} {...loaderProps} />;

  const WithMessage = (
    <Stack justify="center" align="center">
      {Loading}
      {message ? <Text size="xl">{message}</Text> : null}
    </Stack>
  );

  if (isFullPageLoading)
    return (
      <Center sx={{ minHeight: '40vh', textAlign: 'center' }}>
        {WithMessage}
      </Center>
    );

  return message ? WithMessage : Loading;
};
